
  export default {
    props: {
      typeCategories: Array,
      topicCategories: Array,
      showTypeFilter: Boolean,
      showTopicFilter: Boolean,
      maxItemsToDisplay: Number,
      hideImages: Boolean,
      hideTeaserText: Boolean,
      filterLabel: String,
      initialTypeFilter: String,
      initialTopicFilter: String
    },
    data() {
      return {
        resources: [],
        typeFilter: '',
        topicFilter: '',
        loading: true,
        displayCount: 0
      }
    },
    computed: {
      filteredResources() {
        let results = this.resources
        if (this.typeFilter) {
          results = results.filter(r => r.categories.some(c => c.identifier === this.typeFilter))
        }
        if (this.topicFilter) {
          results = results.filter(r => r.categories.some(c => c.identifier === this.topicFilter))
        }
        if (this.maxItemsToDisplay === 0) {
          return results
        } else {
          return results.slice(0, this.maxItemsToDisplay)
        }
      }
    },
    beforeMount() {
      this.typeFilter = this.initialTypeFilter
      this.topicFilter = this.initialTopicFilter
      this.initializeDisplayCount()
      this.fetchResources()
    },
    methods: {
      fetchResources() {
        fetch("/webapi/resourcesapi/categories")
          .then(response => response.json())
          .then(json => {
            this.loading = false;
            this.resources = json
          })
      },
      loadMore() {
        this.displayCount = Number.MAX_SAFE_INTEGER
      },
      initializeDisplayCount() {
        this.displayCount = 8
      },
      resetFilters() {
        if (this.showTypeFilter) {
          this.typeFilter = ''
        }
        if (this.showTopicFilter) {
          this.topicFilter = ''
        }
        this.initializeDisplayCount()
      }
    }
  }
